import {Component, EventEmitter, Input, Output} from '@angular/core';
import {InfoModalComponent} from "../../views/modal/info_modal.component";
import {ModalService} from "../../views/modal/base_modal.component";
import {TranslateService} from "../../translate/translate.service";
import {FilterFormService} from "../../views/filter_form/filter_form.service";
import {HelperService} from "../../lib/helper.service";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {AccessorService} from "./accessor.service";
import {AlertComponent} from "../../views/modal/alert.component";

@Component({
	selector: 'accessor-mystats',
	template: `
		<info-modal [title]="title" (onOk)="ok()">
			<loading [isLoad]="!stats || (stats && stats.length == 0)"></loading>

			<table class="table">
				<thead>
					<th>{{ 'adminstat.support.accessor.time' | translate }}</th>
					<th>{{ 'adminstat.common.Site' | translate }}</th>
					<th>{{ 'adminstat.support.accessor.isSet' | translate }}</th>
					<th>{{ 'adminstat.support.accessor.at the moment' | translate }}</th>
					<th>&nbsp;</th>
				</thead>

				<tbody>
					<tr *ngFor="let stat of stats">
						<td>
							 {{ stat.time || '' }}
						</td>

						<td>
							<a target="_blank" rel="noreferrer" [href]="'http://' + stat.url">{{ stat.domainUrl }}</a>
						</td>

						<td>
							<ng-container *ngIf="mark == 'edit'">
								{{ stat.category }} - {{ stat.subCategory }}
							</ng-container>

							<ng-container *ngIf="mark != 'edit'">
								{{ 'adminstat.support.accessor.site is defered' | translate }}
							</ng-container>
						</td>

						<td>
							<ng-container *ngIf="stat.realCategory == null && stat.realSubCategory == null">
								{{ 'adminstat.support.accessor.not setted' | translate }}
							</ng-container>
							
							<ng-container *ngIf="stat.realCategory != null || stat.realSubCategory != null">
								{{ stat.realCategory }} - {{ stat.realSubCategory }}
							</ng-container>
						</td>

						<td>
							<button type="button" class="btn btn-outline-dark btn-sm">
								<i class="fa fa-pencil-alt" aria-hidden="true" style="cursor:pointer;" (click)="editSiteCategory(stat.siteId)"></i>
							</button>
						</td>
					</tr>
				</tbody>
			</table>
		</info-modal>
	`
})
export class AccessorMyStatsModalComponent extends InfoModalComponent {
	@Output() getIframeData = new EventEmitter<boolean>();
	
	stats;

	type: any;
	start: any;
	end: any;

	constructor(
		public activeModal: NgbActiveModal,
		public helper: HelperService,
		public translate: TranslateService,
		public modalService: ModalService,
		public filter: FilterFormService,
		public service: AccessorService
	) {
		super(activeModal);
	}

	ok() {
		this.close();
	}

	async editSiteCategory(siteId: string) {
		let check: any = await this.service.checkSite({ siteId: siteId }).toPromise();
		if (check.status == 'error') {
			this.modalService.open(AlertComponent, {
				title: 'ERROR',
				message: this.translate.__A('support.accessor.site is editing now')
			});
			return true;
		}

		let data = await this.service.updateSite({ siteId: siteId }).toPromise();

		this.close();

		if (data == 1) {
			this.getIframeData.emit(true);
		}
	}
}
